import {SettingDescription, SettingValue, type SettingId , SettingsBank, type SettingBankDefinition} from "./Settings";

export enum UserSettingIds {
    LicenseToolsEnabled = "LicenseToolsEnabled",
    SoundCacheEnabled = "SoundCacheEnabled",
}

export const UserSettingsBankDescription: SettingBankDefinition = {
    LicenseToolsEnabled: new SettingDescription<boolean>({
        id: UserSettingIds.LicenseToolsEnabled,
        description: "Advanced licensing tools",
        tooltip: "Enable advanced licensing tools, such as automatic copyright notice generation.",
        defaultValue: false,
        isExperimental: true,
    }),
    SoundCacheEnabled: new SettingDescription<boolean>({
        id: UserSettingIds.SoundCacheEnabled,
        description: "Enable the sound cache",
        tooltip: "Enable the sound cache.",
        defaultValue: true,
        isExperimental: true,
    }),
}

export type UserSettings = "maker";